/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrendsSkeleton.defs'
export { main as default } from './getTrendsSkeleton.defs'
